// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__2rVWR","header":"ReportDetails_header__3KJ7g","title":"ReportDetails_title__1YOlP","left":"ReportDetails_left__2ZGiy"};